import * as React from 'react';

import States from 'login-constants/states';
import ContextLink from '../Common/ContextLink';

const LoanEstimateSubtitleLink = () => (
  <div>
    Get a more accurate Loan Estimate with a full application. Please keep in mind that the usefulness of a Loan
    Estimate depends in part on the information you provide. It is not too late to{' '}
    <ContextLink isWhite to={States.CREATE_ACCOUNT}>
      submit a full application
    </ContextLink>
  </div>
);
export default LoanEstimateSubtitleLink;
